import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CreditCardOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#clip0_608_74)" fill={color}>
      <Path d="M18.66 10.6c.4 0 .74.34.74.74v7.33c0 .4-.34.74-.74.74H5.34c-.4 0-.74-.34-.74-.74v-7.33c0-.4.34-.74.74-.74h13.33m0-1.6H5.34C4.05 9 3 10.05 3 11.34v7.33c0 1.29 1.05 2.34 2.34 2.34h13.33c1.29 0 2.34-1.05 2.34-2.34v-7.33c0-1.29-1.05-2.34-2.34-2.34z" />
      <Path d="M6.81 13.8h3.8c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8h-3.8c-.44 0-.8.36-.8.8 0 .44.36.8.8.8zM9.19 16.2H6.8c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2.39c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8zM13.4 16.2h-2.39c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2.39c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8zM17.62 16.2h-2.39c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h2.39c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8zM6.01 8.48l1.38-3.42a.748.748 0 01.96-.41l9.52 3.83h2.34a2.32 2.32 0 00-1.29-1.3L8.95 3.17C8.67 3.06 8.37 3 8.08 3c-.93 0-1.81.55-2.17 1.46L4.29 8.48h1.72z" />
      <Path d="M8.7 7.91l1.69.57h2.94a.776.776 0 00-.52-.87L9.21 6.4a.794.794 0 00-1.01.5c-.14.42.08.87.5 1.01z" />
    </G>
    <Defs>
      <ClipPath id="clip0_608_74">
        <Path fill="#fff" d="M0 0H24V24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CreditCardOutlined
